<template>
  <div>
    <a-modal v-model="visible" class="mobile-modal-fullscreen-msg-modal" :footer="null" :centered="true" :closable="false" width="587px">
      <div class="header mob-shadow">
        <!-- <div  @click="CancelModal()" class="open-mob">
              <font-awesome-icon size="1x" class="xmark-mob" :icon="['far', 'times']"/>
          </div> -->
        <font-awesome-icon @click="CancelModal()" class="open-mob font-black mr-3 font20 cp" size="2x" :icon="['fal', 'times']" />
        <span class="title">Message</span>
        <!-- <div  @click="CancelModal()" class="close-mob">
              <font-awesome-icon size="1x" class="xmark" :icon="['far', 'times']"/>
          </div> -->
        <font-awesome-icon @click="CancelModal()" class="close-mob font-black mr-3 font20 cp" size="2x" :icon="['fal', 'times']" />
        <button @click="postUpdates()" class="apply-filter-btn-mob" :style="{ background: getPrimaryColor() }">Submit</button>
      </div>
      <div class="d-flex message-container">
        <div class="d-flex flex-direction-row avatar-container" :style="{ gap: '8px' }">
          <a-avatar
            :size="40"
            class="text-capitalize mr-2"
            :style="{ color: ' #ffffff !important', 'background-color': authUser.user.url ? authUser.user.url : '' ? '' : '#C997C5' }"
            :src="authUser.user.url"
          >
            {{ authUser.user.display_name[0] }}
          </a-avatar>
          <p class="title text-capitalize">
            {{ authUser.user.display_name }}
          </p>
        </div>

        <div :style="{ height: '123px' }">
          <textarea class="textarea1" :autofocus="true" ref="textarea" cols="60" rows="4" :maxlength="2000" :placeholder="placeText + '' + name" v-model="postPayload.post_text"></textarea>
          <div class="d-flex" :style="{ 'justify-content': 'space-between' }">
            <CustomEmojiPicker :visible="emojiVisible" :handleVisible="handleEmojiVisible" :insert="insert" />
            <span class="desc-text">{{ postPayload.post_text.length }}/2000</span>
          </div>
        </div>

        <div class="note-message">
          <h3 class="note-text">Please note that this message is NOT private and will be visible to all members</h3>
        </div>

        <div class="btns">
          <button class="button-cancel" @click="CancelModal">Cancel</button>
          <a-button class="button-submit" :loading="loading" :disabled="!postPayload.post_text" @click="postUpdates()" :style="{ background: getPrimaryColor() }">Submit</a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import CustomEmojiPicker from "../../components/home/EmojiPickerMessage.vue"
import { RepositoryFactory } from "../../repositories/RepositoryFactory"
const PostRepository = RepositoryFactory.get("posts")
export default {
  name: "MessageUserModal",
  data() {
    return {
      visible: false,
      message: null,
      emojiVisible: false,
      postPayload: { post_text: "", day_type: "" },
      User: undefined,
      placeText: "Say Hi to ",
      name: "",
    }
  },
  components: {
    /// quillEditor,
    CustomEmojiPicker,
  },
  mounted() {
    this.focusInput()
  },

  created() {
    this.name =
      this.viewUser.role === "hospital"
        ? this.viewUser.hospital_info.hospital_name || "H"
        : this.viewUser.role === "clinic"
        ? this.viewUser.clinic_info.clinic_name || "C"
        : this.viewUser.role === "hcp"
        ? this.viewUser.display_name
          ? this.viewUser.display_name
          : this.viewUser.hcp_info.hcp_name || "HCP"
        : this.viewUser.role === "nfp"
        ? this.viewUser.display_name
          ? this.viewUser.display_name
          : this.viewUser.nfp_info.nfp_name
          ? this.viewUser.nfp_info.nfp_name
          : this.viewUser.nfp_info.full_name || "NFP"
        : this.viewUser.display_name
        ? this.viewUser.display_name
        : this.viewUser.doctor_info.full_name || ""

    // this.name = this.name.replace(/\b(\w)/g, s => s.toUpperCase())
    window.addEventListener("mouseup", () => {
      if (this.emojiVisible) {
        setTimeout(() => {
          this.emojiVisible = false
        }, 100)
      }
    })
  },

  methods: {
    ShowModal(viewUser) {
      this.User = viewUser
      this.visible = !this.visible
    },
    focusInput() {
      // this.$refs.textarea.focus();
    },
    CancelModal() {
      this.visible = false
      this.postPayload.post_text = ""
      this.postPayload.day_type = ""
      this.closeEmoji()
    },
    // closeAll() {
    //   if (this.emojiVisible) {
    //     this.closeEmoji();
    //   }
    // },
    getUserName() {
      if (this.User.role === "doctor" || this.User.role === "hcp") {
        return this.User.first_name + " " + this.User.last_name
      } else {
        return this.User.display_name
      }
    },
    postUpdates() {
      this.loading = true
      this.closeEmoji()
      const payload = {
        user_circle: this.currentCircle.id,
        user: this.authUser.user.id,
        role: this.authUser.role,
        day_type: this.postPayload.day_type,
        post_text: this.postPayload.post_text,
        receiver_user: this.viewUser.id,
        receiver_role: this.viewUser.role,
      }
      PostRepository.createPost(payload)
        .then(res => {
          this.loading = false
          this.visible = false
          this.postPayload.post_text = ""
          this.$notification.success({ message: "Success", description: "Message Delivered Successfully." })
          this.$store.commit("Posts/setMsg", true)
        })
        .catch(err => {
          this.loading = false
          this.visible = false
        })
    },
    closeEmoji(e) {
      this.emojiVisible = false
    },
    handleEmojiVisible() {
      this.emojiVisible = !this.emojiVisible
    },
    insert(emoji) {
      this.postPayload.post_text += emoji
    },
  },
}
</script>

<style lang="scss" scoped>
.open-mob {
  display: none;
  @media screen and (max-width: 700px) {
    display: flex;
  }
}
.close-mob {
  display: flex;
  @media screen and (max-width: 700px) {
    display: none;
  }
}

.apply-filter-btn-mob {
  display: none;
  @media screen and (max-width: 700px) {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 12px 24px;
    // width: 82px;
    // height: 48px;
    border-radius: 6px;
    text-transform: capitalize;
    color: #ffffff;
    border: none;
    // cursor: pointer;
  }
}

.xmark-mob {
  // width:12.5px;
  margin-right: 24px;
  height: 20px;
  cursor: pointer;
  color: #94a3b8;
}
.xmark {
  // width:12.5px;
  height: 20px;
  cursor: pointer;
  color: #94a3b8;
}
.title {
  width: 100%;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #33415f;
  @media screen and (max-width: 700px) {
    font-size: 20px !important;
  }
}
.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  // padding: 24px;
  // padding-bottom: 0;
  width: 100%;
  margin-bottom: 24px;
  @media screen and (max-width: 600px) {
    padding: 16px;
    padding-bottom: 16px;
  }
}
.desc-text {
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  text-align: right;
  text-transform: capitalize;
  color: #94a3b8;
}
.message-container {
  gap: 24px;
  flex-direction: column;
  // padding: 24px;
  // padding-top: 0;
  @media screen and (max-width: 600px) {
    padding: 16px;
    padding-top: 0;
  }
  .avatar-container {
    .title {
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      color: #000000;
      display: flex;
      align-self: center;
      margin-bottom: 0px;
    }
  }

  .note-message {
    @media screen and (max-width: 900px) {
      margin-top: 70%;
    }
    padding: 16px;
    background: #f8fafd;
    border-radius: 8px;
    .note-text {
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      color: #33415f;
    }

    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #33415f;
  }

  .btns {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    padding: 0px;
    gap: 10px;
    @media screen and (max-width: 700px) {
      display: none;
    }
  }

  .button-cancel {
    padding: 12px 24px;
    background: #e2e8f0;
    border-radius: 6px;
    border: none;
  }
  .button-cancel span {
    color: #47556e !important;
  }

  .button-submit {
    background: #2a71d4;
    border-radius: 6px;
    padding: 12px 24px;
    color: white;
  }
  .textarea1 {
    border: none;
    outline: none;
    resize: none;
    &:focus {
      outline: none;
      border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/MessageUserModal.vue